export default __webpack_public_path__ + "img/neuquen.a3620e8d.jpg";